import axios  from 'axios';
import qs from 'qs';               
import { signParams } from '@yqz/base';



const instance = axios.create({
  baseURL: process.env.REACT_APP_AGILE,
  timeout: 8000,
  paramsSerializer: function (params) {
    const p = signParams({ ...params,pl_user: 'react_worker' }, process.env.REACT_APP_SECRET || '');
    return qs.stringify(p, { arrayFormat: 'repeat' });
  }
});

export default instance;